export default __webpack_public_path__ + "static/media/wheelchair-tennis-red.a112e7c5.png";